const vi = {
  name: "vi",
  months: [
    ["Tháng 1", "T1"],
    ["Tháng 2", "T2"],
    ["Tháng 3", "T3"],
    ["Tháng 4", "T4"],
    ["Tháng 5", "T5"],
    ["Tháng 6", "T6"],
    ["Tháng 7", "T7"],
    ["Tháng 8", "T8"],
    ["Tháng 9", "T9"],
    ["Tháng 10", "T10"],
    ["Tháng 11", "T11"],
    ["Tháng 12", "T12"],
  ],
  weekDays: [
    ["Thứ bảy", "Bảy"],
    ["Chủ nhật", "CN"],
    ["Thứ hai", "Hai"],
    ["Thứ ba", "Ba"],
    ["Thứ tư", "Tư"],
    ["Thứ năm", "Năm"],
    ["Thứ sáu", "Sáu"],
  ],
  digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  meridiems: [
    ["SA", "sa"],
    ["CH", "ch"],
  ],
};

export default vi;
